import React from 'react'
import {
    IconButton,
    Link,
    Tooltip,
} from '@material-ui/core'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { createMailToLink } from '../../utils/MailToLink'

const useStyles = makeStyles(theme => ({
    errorIcon: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        marginRight: "2rem",
        "&:hover": {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        }
    },
}))

const singleNewLine = "%0D%0A"

const ReportClauseButton = ({ clause }) => {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
        <Link target="_blank" rel="noopener" href={
            createMailToLink({
                to: "servicedesk@fednot.be",
                subject: t('email.reportClause.subject', { clauseId: clause.clause_id }),
                body: t('email.reportClause.body', { returnObjects: true }).join(singleNewLine.repeat(2)),
            })
        }>
            <Tooltip title={t('tooltips.reportClause')} aria-label="Report clause">
                <IconButton className={classes.errorIcon} size="large" color="error" variant="outlined">
                    <ReportProblemIcon />
                </IconButton>
            </Tooltip>
        </Link >
    )
}

export default ReportClauseButton
